import Trans from '../locales/Trans';
import Misc from 'composer-blocks/lib/locales/Misc.js';

export const availableLanguages = ['en', 'es', 'fr', 'it', 'pt', 'pt-BR', 'de', 'ca', 'nl', 'ar', 'vi', 'zh', 'zh-TW', 'ko', 'ja'];

const translations = {};
availableLanguages.forEach((lang) => {
  translations[lang] = {
    Trans: { ...Trans[lang] },
    Misc: { ...Misc[lang] },
  };
});

export default translations;
